import { useCallback } from 'react';

import { DosageTemplateStatisticIncrementUsageCommand } from '@dreryk/egabinet-prescription-frontend-api';

import { useCqrsCommand } from '@dreryk/command-query-react-common';

import { ExtendedDosage } from '~libs.shared.prescription';

import { DosageTemplateUse } from '../../../prescriptionTemplates/extendedDosage/DosageTemplates.types';

const createIncrementUsageCommand = (templateId: number): DosageTemplateStatisticIncrementUsageCommand => {
   const command = new DosageTemplateStatisticIncrementUsageCommand();
   command.dosageTemplateId = templateId;
   return command;
};

const ignoreError = (): void => undefined;

export const useExtendedDosageTemplateUse = (
   applyTemplateExtendedDosage: (extendedDosage: ExtendedDosage) => void
): DosageTemplateUse => {
   const { execute: incrementUsage } = useCqrsCommand<void, number>(createIncrementUsageCommand, {
      background: true,
      onUnexpectedError: ignoreError,
   });

   return useCallback(
      (template) => {
         applyTemplateExtendedDosage(template.extendedDosage);
         incrementUsage(template.id);
      },
      [applyTemplateExtendedDosage, incrementUsage]
   );
};
